define([
	"dojo/_base/declare",
	"csi/heading/RefImage",
	"./CareSymbolRendererMixin",
	"./CareIconPerLanguageRendererMixin"
], function(declare,RefImage,CareSymbolRendererMixin,CareIconPerLanguageRendererMixin) {

	return declare([RefImage,CareSymbolRendererMixin,CareIconPerLanguageRendererMixin], {

	});
});
